import React from "react";
import { useState, useEffect } from "react";
import { Route, Routes, Navigate, useSearchParams } from "react-router-dom";
import withRouter from "../Router/withRouter";
import classnames from "classnames";
import { Box, IconButton, Link } from "@mui/material";
import Icon from "@mdi/react";
import Toolbar from "@mui/material/Toolbar";
//icons
import {
  mdiFacebook as FacebookIcon,
  mdiTwitter as TwitterIcon,
  mdiGithub as GithubIcon,
} from "@mdi/js";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../pages/dashboard";
import DashboardIL from "../../pages/dashboard/DashboardIL";
import HomePage from "../../pages/home/HomePage";

// import Typography from "../../pages/typography";
// import Notifications from "../../pages/notifications";
// import Maps from "../../pages/maps";
// import Tables from "../../pages/tables";
// import Icons from "../../pages/icons";
// import Charts from "../../pages/charts";

//contexts
import { useLayoutState } from "../../context/LayoutContext";
import { useLocation } from "react-router-dom";
//console.log("DashboardIL", DashboardIL);

function Layout(props) {
  const [searchParams] = useSearchParams();
  const [viewMode, setViewMode] = useState("full");
  const [stateMode, setStateMode] = useState("tx");
  useEffect(() => {
    //Set the view mode based on the url parameter
    const view = searchParams.get("view") || "full";
    if (view === "full") setViewMode("full");
    if (view === "main") setViewMode("main");
    const state = searchParams.get("state") || "tx";
    if (state !== "tx") setStateMode(state.toLowerCase());
  }, [searchParams]);

  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
      <>
        {viewMode === "full" && (
          <>
            <Header history={props.history} />
            <Sidebar />
          </>
        )}
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          {/* <Toolbar/> used here to padding the top banner */}
          {viewMode === "full" && <Toolbar></Toolbar>}
          <Routes>
            <Route path="/" element={<HomePage />} />
            {stateMode === "tx" && (
              <Route path="/dashboard" element={<Dashboard />} />
            )}
            {/* {stateMode === "il" && (
              <Route path="/dashboard" element={<DashboardIL />} />
            )} */}
          </Routes>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
